import { system } from 'styled-system'

import * as colors from './colors'
import * as shadow from './boxShadow'

export const HEADER_BUTTON_WIDTH = '40px'

const zIndex = {
  section: 1000,
  heading: 1001,
  sectionJourneyStartText: 1001,
  sectionColorPicker: 1001,
  bottle: {
    shellBack: 1002,
    bottleTopBg: 1002,
    glass: 1003,
    layer: 1004,
    shellFront: 1005,
    spout: 1003,
    cap: 1005,
    loader: 1005,
  },
  eye: {
    text: 1005,
    art: 1003,
  },
  pure: {
    text: 1005,
    art: 1003,
    actionText: 1005,
    heading: 1008,
    headingBar: 1007,
    subheading: 1004,
  },
  feeling: {
    art: 1001,
    heading: 1002,
    subheading: 1007,
    headingBar: 1002,
  },
  taste: {
    art: 1001,
    heading: 1004,
    subheading: 1004,
    headingBar: 1002,
  },
  ride: {
    art: 1003,
    stamp: 1006,
    text: 1005,
    heading: 1008,
  },
  fill: {
    art: 1003,
    text: 1005,
    headingBar: 1002,
  },
  control: {
    text: 1005,
    art: 1003,
    heading: 1007,
    headingBar: 1007,
  },
  nav: 1002,
  header: 1003,
  journeyNav: 1003,
  footer: 1003,
  drawer: 1004,
  swatchPicker: 1003,
  muteButton: 1004,
  modal: 1005,
  journeyEnd: 1005,
  landingZIndex: 9000,
  fpsMeter: 10000,
}

export interface UppercaseProps {
  uppercase?: boolean
}

export const uppercase = system({
  uppercase: {
    property: 'textTransform',
    transform: (n) => (n ? 'uppercase' : undefined),
  },
})

export const highlight = (color: string, padding: string) => ({
  boxShadow: `${padding} 0 0 ${color}, -${padding} 0 0 ${color}`,
})

export const createMediaQuery = (minWidth: string, maxHeight?: string) =>
  `@media screen and (min-width: ${minWidth})${
    maxHeight ? ` and (max-height: ${maxHeight})` : ''
  }`

export { colors, shadow, zIndex }
